import { object, string } from 'yup'

export { member as baseURL } from 'constants/apiBaseUrls'

export const Schema = object().shape({
  memberId: string().required(),
})

export const url = ({ memberId }) => `/v2/members/${memberId}/services`
